<template>
  <div class="casetjhfbdls text_center">
    <sec-title Text="为您推荐合肥本地律师" />
    <div class="caselaycard between wrap">
      <div
        v-for="(item, index) in 8"
        :key="index"
        class="laycard_item"
        :class="{ active: index == is_active }"
        @mouseover="is_active = index"
        @mouseout="is_active = -1"
      >
        <div class="it_cover">
          <img src="../../../assets/case/aaaa1_sample.png" alt="" />
        </div>
        <div class="it_name">李XX律师</div>
        <div class="it_des">合同纠纷 刑事纠纷 交通事故</div>
        <div class="it_fwrs">服务人数<span>1111</span>人</div>
        <div>
          <div class="it_tel">18955555555</div>
          <div class="it_btn">在线咨询</div>
        </div>
      </div>
    </div>
    <!-- <view-more /> -->
  </div>
</template>

<script>
import secTitle from "../../home/components/secTitle";
import viewMore from "../../home/components/viewMore";
export default {
  components: {
    secTitle,
    viewMore,
  },
  data: () => ({
    is_active: -1,
  }),
};
</script>

<style lang="scss" scope>
.casetjhfbdls {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .caselaycard {
    margin-top: 80px;
    height: 540px;
    align-items: flex-start;
    .laycard_item {
      width: 280px;
      height: 230px;
      margin-bottom: 80px;
      background: #ffffff;
      box-shadow: 0px 3px 27px 0px rgba(0, 0, 0, 0.15);
      padding-top: 90px;
      position: relative;
      font-size: 14px;
      transition: all 0.3s;
      .it_cover {
        position: absolute;
        top: -42px;
        left: 50%;
        width: 106px;
        height: 106px;
        border-radius: 50%;
        transform: translateX(-50%);
      }
      .it_name {
        font-size: 20px;
        color: #333333;
        line-height: 20px;
      }
      .it_des {
        color: #666666;
        line-height: 14px;
        margin: 18px 0;
      }
      .it_fwrs {
        color: #666666;
        line-height: 14px;
        span {
          color: #da0000;
        }
      }
      .it_tel {
        display: none;
      }
      .it_btn {
        display: none;
      }
    }

    .active {
      height: 255px;
      border-bottom: 6px solid #0465ea;
      margin-bottom: 0;
      .it_fwrs {
        display: none;
      }
      .it_tel {
        display: block;
        font-size: 18px;
        color: #333333;
        line-height: 18px;
      }
      .it_btn {
        display: block;
        font-size: 14px;
        width: 95px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        margin: 16px auto 0;
        border-radius: 30px;
        cursor: pointer;
        background-image: linear-gradient(90deg, #71adff, #3c8eff);
      }
    }
  }
}
</style>